import React from 'react';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

export const styles = theme => ({
	root: {
		display: 'block',
	},
	asterick: {
		color: theme.palette.error.main,
	},
});

 const ReduxFormSelect = ({
	classes,
	description,
	fullWidth,
	input: { name, onBlur, onFocus, value, ...otherInput },
	labelShrink,
	menuOptions,
	meta: { error, touched },
	placeholder,
	required,
	style,
	...custom
}) => (
	<FormControl className={classes.root} error={touched && !!error} style={style}>
		{placeholder && (
			<InputLabel htmlFor={name} shrink={labelShrink}>
				{placeholder}
				{required && !!error ? <span className={classes.asterick}> *</span> : null}
			</InputLabel>
		)}
		<Select
			style={fullWidth ? { width: '100%' } : {}}
			inputProps={{ id: name, name }}
			value={value}
			onFocus={() => onFocus(value)} // sometimes focus and blur events pass back an incorrect value
			onBlur={() => onBlur(value)} // so manually specify the value in the callback
			{...otherInput}
			{...custom}
		>
			{menuOptions.map(option => (
				<MenuItem value={option.value} key={option.value}>
					{option.displayText}
				</MenuItem>
			))}
		</Select>
		{(touched && !!error && <FormHelperText>{error}</FormHelperText>) ||
			(description && <FormHelperText>{description}</FormHelperText>)}
	</FormControl>
);

ReduxFormSelect.propTypes = {
	input: PropTypes.shape({
		name: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired,
		onFocus: PropTypes.func.isRequired,
		onBlur: PropTypes.func.isRequired,
	}),
	description: PropTypes.string,
	meta: PropTypes.shape({ touched: PropTypes.bool, error: PropTypes.string }),
	placeholder: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
	}).isRequired,
	fullWidth: PropTypes.bool,
	required: PropTypes.bool,
	labelShrink: PropTypes.bool,
	menuOptions: PropTypes.arrayOf(
		PropTypes.shape({
			displayText: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
		}),
	).isRequired,
	style: PropTypes.shape({}),
};

ReduxFormSelect.defaultProps = {
	input: {},
	labelShrink: undefined,
	meta: {},
	description: null,
	placeholder: null,
	required: false,
	fullWidth: false,
	style: undefined,
};

export default withStyles(styles, { name: 'ReduxFormInput' })(ReduxFormSelect);
